// extracted by mini-css-extract-plugin
module.exports = {"tumor-toolbar-wrapper":"TumorToolbar_tumor-toolbar-wrapper__26-Hx"};